import React, {Component} from 'react';
import '../App.css';
import axios from 'axios';
import cookie from 'react-cookies';
import Select from 'react-select'

class Setting extends Component{
	//call the constructor method
	constructor(props){
		
		super(props);
		
		this.getCountryList();

		this.state = {
			useremail : "",
			first_name: "",
			last_name: "",
			mobile_number: "",
			status: 0,
			options: [],
			selectedCountryOption: {value: 0, label: ''},
			file: null
		}

		// this.emailChangeHandler = this.emailChangeHandler.bind(this);
		// this.firstNameChangeHandler = this.firstNameChangeHandler.bind(this);
		// this.lastNameChangeHandler = this.lastNameChangeHandler.bind(this);
		this.submitSetting = this.submitSetting.bind(this);
		this.handleChange = this.handleChange.bind(this)
	}
	
	componentWillMount(){
		
	}

	componentDidMount(){
		this.setState({
			imageUrl: this.props.imageUrl
		})
	}

	getCountryList() {
		axios.defaults.withCredentials = true;
		
		axios.get(window.$backend_url + '/getCountryList')
			.then(response => {
				if ( response.status === 200 ) {
					var countryList = [];

					for (var i=0; i<response.data.length; i++) {
						countryList.push({ value: response.data[i].id, label: response.data[i].name });
					}

					this.setState({
						options: countryList
					});

					this.getUserData();
				}
			})
	}

	getUserData() {
		const userdata = {
			userid: cookie.load('cookieId')
		}

		axios.defaults.withCredentials = true;
		
		axios.post(window.$backend_url + '/getUserInfo', userdata)
			.then(response => {
				if(response.status === 200){
					this.setState({
						useremail : response.data[0].email,
						first_name: response.data[0].first_name,
						last_name: response.data[0].last_name,
						mobile_number: response.data[0].phone_number
					})
					
					var filteredOptions = this.state.options.filter(
						(option) =>
						option.value == response.data[0].country
					);

					if (filteredOptions.length) {
						this.setState({
							selectedCountryOption: filteredOptions[0]
						})
					}
				}
			})
			.catch(error => {

			})
	}
	
	mobileNumberChangeHandler = (e) => {
		this.setState({
			mobile_number : e.target.value
		})
	}

	changeCountryHandler = selectedCountryOption => {
		this.setState({
			selectedCountryOption: selectedCountryOption
		});

	}

	switchPopupChangePwd = (e) => {
		e.preventDefault();
		this.props.switchPopupChangePwd();
	}

	handleValidation(){
		let formIsValid = true;

		if(!this.state.useremail){
		   formIsValid = false;
		   alert("Useremail is a Required field");
		}

		if(!this.state.first_name){
			formIsValid = false;
			alert("First name is a Required field");
		}

		if(!this.state.last_name){
			formIsValid = false;
			alert("Last name is a Required field");
		}

		return formIsValid;
	}
	
	submitSetting = (e) => {
		e.preventDefault();

		if (this.state.selectedCountryOption) {
			localStorage.setItem('countryId', this.state.selectedCountryOption.value);
		} else {
			localStorage.setItem('countryId', 0);
		}

		const data = {
				userid : cookie.load('cookieId'),
				mobile_number : this.state.mobile_number,
				country : this.state.selectedCountryOption.value
			};

		axios.defaults.withCredentials = true;
		
		axios.post(window.$backend_url + '/update-user', data)
			.then(response => {
			})		

		if ( this.state.file ) {
			const formData = new FormData();
			formData.append('userid', cookie.load('cookieId'));
			formData.append('file', this.state.file);

			const config = {
				headers: {
					'content-type': 'multipart/form-data'
				}
			};

			axios.post(window.$backend_url + '/upload-avatar', formData, config)
				.then(response => {
					this.props.closeSettingPopup();
				})
		} else {
			this.props.closeSettingPopup();
		}
			
	}

	switchPopupLogin = (e) => {
		e.preventDefault();
		this.props.switchPopupLogin();
	}

	handleChange(e){
		this.setState({
			imageUrl: URL.createObjectURL(e.target.files[0]),
			file: e.target.files[0]
		})
	}

	handleFileSelect = (e) => {
		e.preventDefault();
		document.getElementById('profile_img').click();
	}

	render(){
		const { selectedCountryOption } = this.state;

		const customStyles = {
			control: styles => ({ 
				...styles,
				backgroundColor: '#313131',
				color: '#ffd33f',
				border: 'solid 1px #64541c',
				boxShadow: 'none',
				outline: 'none',
				"&:hover": {
					border: 'solid 1px #ffd33f',
					color: 'white',
					outline: 'none',
					boxShadow: 'none'
				},
				"&:focus": {
					border: 'solid 1px #ffd33f',
					color: 'white',
					outline: 'none',
					boxShadow: 'none'
				}
			}),
			option: (styles, { data, isDisabled, isFocused, isSelected }) => {
				return {
					backgroundColor: isFocused ? '#ddd' : 'white',
					color: isFocused ? 'black' : 'gray',
					padding: '10px',
					size: 5,
					"&:hover": {
						border: 'none',
						boxShadow: 'none',
						outline: 'none'
					},
					"&:focus": {
						border: 'none',
						boxShadow: 'none',
						outline: 'none'
					}
				};
			},
			container: (base, state) => ({
				...base,
				border: state.isFocused ? null : null,
				"&:hover": {
					border: 'none',
					boxShadow: 'none',
					outline: 'none'
				},
				"&:focus": {
					border: 'none',
					boxShadow: 'none',
					outline: 'none'
				}
			}),
			singleValue: (provided, state) => ({
				...provided,
				color: "#ffd33f",
				"&:hover": {
					border: 'none',
					boxShadow: 'none',
					outline: 'none'
				},
				"&:focus": {
					border: 'none',
					boxShadow: 'none',
					outline: 'none'
				}
			})
		}

		return(			
			<div className="custom-modal setting-modal">
				<h2 className="text-center">{this.props.dataLanguage['user_account']}</h2>
				<form className="user-setting-form">
					<div className="modal-logo">
						<div className="profile-img"><img alt="" src={ this.state.imageUrl } /></div>
						<input type="file" accept=".png,.jpg" onChange={this.handleChange} id="profile_img" name="profile_img" className="hidden" />
					</div>
					<div className="text-center">
						<p className="subtitle">{this.state.first_name} {this.state.last_name}</p>
						<button type="button" className="btn_change_charactor" onClick={this.handleFileSelect}>{this.props.dataLanguage['change_pic']}</button> 
					</div>
					<div className="form-group">
						<label>{this.props.dataLanguage['firstName']}</label>						
						<input type="text" className="form-control first_name" name="first_name" value={this.state.first_name} disabled />
					</div>
					<div className="form-group">
						<label>{this.props.dataLanguage['lastName']}</label>
						<input type="text" className="form-control last_name" name="last_name" value={this.state.last_name} disabled />
					</div>
					<div className="form-group">
						<label>{this.props.dataLanguage['mobile_number']}</label>
						<input onChange = {this.mobileNumberChangeHandler} type="text" className="form-control mobile_number" name="mobile_number" placeholder="(optional)" value={this.state.mobile_number} />
					</div>
					<div className="form-group">
						<label>{this.props.dataLanguage['email']}</label>
						<input type="email" className="form-control" name="useremail" value={this.state.useremail} disabled />
					</div>
					<div className="form-group">
						<label>{this.props.dataLanguage['country']}</label>
						<Select styles={customStyles} options={this.state.options} onChange={this.changeCountryHandler} value={selectedCountryOption} />
					</div>
					<button onClick = {this.switchPopupChangePwd} type="submit" className="btn-submit">{this.props.dataLanguage['changePwd']}</button>
					<button onClick = {this.submitSetting} type="submit" className="btn-submit btn-update-setting">{this.props.dataLanguage['update_settings']}</button>
				</form>
			</div>
		)
	}
}

export default Setting;


// WEBPACK FOOTER //
// ./src/components/Setting.js